import Vue from 'vue';


export const addLead = (state, lead) => {

    state.project_lead = lead;
};